var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/orderlist/list.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-orderdetail-popup\">\n    <div class=\"layer-mask\"></div>\n    <div class=\"layer-body\">\n       <div class=\"layer-close\">\n           <i class=\"iconfont icon-close\"></i>\n       </div>\n       <div class=\"layer-list\">\n               <div class=\"list-package-index\">\n                  ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "\n               </div>\n                ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                    <div class=\"normal-item\">\n                        <div class=\"item-body\">\n                            <div class=\"img-wrap\">\n                                <div class=\"img\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.memberLookup((t_4),"image"), env.opts.autoescape);
output += "),url(//gw.alicdn.com/tfs/TB1SBlCSXXXXXX.aXXXXXXXXXXX-340-340.jpg)\"></div>\n                            </div>\n                            <div class=\"info-wrap\">\n                                <div class=\"info-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "</div>\n                                <div class=\"info-price\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"formatted_price"), env.opts.autoescape);
output += "</div>\n                            </div>\n                            <div class=\"quantity\">\n                                <span>× ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"quantity"), env.opts.autoescape);
output += "</span>\n                            </div>\n                        </div>\n                    </div>\n                ";
;
}
}
frame = frame.pop();
output += "\n       </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/orderlist/list.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/extension/orderlist/list.html
// module id = 263
// module chunks = 0 1